(function () {
  'use strict';

  function getConfig() {
    return window.EV_CONFIG || window.FPV_CONFIG || {};
  }

  function getCartCountElements() {
    var selectors = [
      '#ev-cart-count',
      '#cart-count',
      '[data-cart-count]',
      '[data-cart-count-bubble]',
      '[data-ev-cart-count]',
      '.cart-count-bubble',
      '.header__cart-count',
      '.ev-cart-count',
      '#cart-icon-bubble'
    ];
    var seen = [];
    var nodes = [];

    selectors.forEach(function (selector) {
      try {
        document.querySelectorAll(selector).forEach(function (el) {
          if (seen.indexOf(el) === -1) {
            seen.push(el);
            nodes.push(el);
          }
        });
      } catch (error) {
        /* invalid selector */
      }
    });

    return nodes;
  }

  function applyCartCount(itemCount) {
    var count = parseInt(itemCount, 10);
    if (isNaN(count) || count < 0) count = 0;
    var isEmpty = count < 1;

    getCartCountElements().forEach(function (el) {
      el.textContent = count;
      el.hidden = isEmpty;
      el.setAttribute('aria-hidden', isEmpty ? 'true' : 'false');
      el.classList.toggle('is-empty', isEmpty);
      el.classList.toggle('has-items', !isEmpty);
    });

    document.querySelectorAll('a.ev-header__utility[href*="/cart"]').forEach(function (link) {
      link.setAttribute(
        'aria-label',
        isEmpty ? 'Cart, empty' : 'Cart, ' + count + ' item' + (count === 1 ? '' : 's')
      );
    });
  }

  function syncCartState(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    applyCartCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('ev:cart:updated', { detail: { cart: cart } }));
  }

  function fetchAndSyncCart() {
    return fetch(getConfig().cartJsUrl || '/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed (' + response.status + ')');
        return response.json();
      })
      .then(function (cart) {
        syncCartState(cart);
        return cart;
      })
      .catch(function (error) {
        console.warn('[EliteVault] Could not refresh cart count:', error.message || error);
        return null;
      });
  }

  function updateCartCount(count) {
    if (typeof count === 'number' && !isNaN(count)) {
      applyCartCount(count);
      return Promise.resolve(count);
    }
    return fetchAndSyncCart();
  }

  function parseCartResponse(response) {
    return response.text().then(function (text) {
      var data = null;
      try { data = text ? JSON.parse(text) : null; } catch (e) { data = null; }
      if (!response.ok) {
        throw new Error((data && (data.description || data.message)) || ('Cart error ' + response.status));
      }
      return data;
    });
  }

  function addVariantToCart(variantId, quantity, properties) {
    var cartAddUrl = getConfig().cartAddUrl || '/cart/add.js';
    var payload = { id: variantId, quantity: quantity || 1 };
    if (properties && typeof properties === 'object') {
      payload.properties = properties;
    }
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(parseCartResponse);
  }

  function addItemsToCart(items) {
    var cartAddUrl = getConfig().cartAddUrl || '/cart/add.js';
    var payloadItems = (items || []).map(function (item) {
      var mapped = {
        id: item.id,
        quantity: item.quantity || 1
      };
      if (item.properties && typeof item.properties === 'object') {
        mapped.properties = item.properties;
      }
      return mapped;
    }).filter(function (item) {
      return item.id && item.quantity > 0;
    });
    if (!payloadItems.length) {
      return Promise.reject(new Error('No items to add'));
    }
    if (payloadItems.length === 1) {
      return addVariantToCart(payloadItems[0].id, payloadItems[0].quantity, payloadItems[0].properties);
    }
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: payloadItems })
    }).then(parseCartResponse);
  }

  function handleCartAddSuccess(data, meta) {
    fetchAndSyncCart().then(function () {
      var detail = Object.assign({ item: data }, meta && typeof meta === 'object' ? meta : {});
      document.dispatchEvent(new CustomEvent('ev:cart:added', { detail: detail }));
      if (!document.querySelector('[data-ev-cart-drawer]')) {
        showCartToast('Added to cart');
      }
    });
  }

  function showCartToast(message) {
    var existing = document.getElementById('ev-cart-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'ev-cart-toast';
    toast.setAttribute('role', 'status');
    toast.className = 'ev-cart-toast';
    toast.textContent = message || 'Added to cart';
    document.body.appendChild(toast);
    setTimeout(function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 2800);
  }

  function syncScrollOffset() {
    var stickySection = document.querySelector('.shopify-section.ev-header-section, section.ev-header-section');
    var header = document.querySelector('[data-ev-header]');
    var el = stickySection || header;
    if (!el) return;
    document.documentElement.style.setProperty('--ev-scroll-offset', el.offsetHeight + 'px');
  }

  var headerScrollRaf = null;
  var headerScrollBound = false;
  var headerScrollEl = null;

  function updateHeaderScrollState() {
    headerScrollEl = document.querySelector('[data-ev-header]');
    if (!headerScrollEl) return;
    var isScrolled = window.scrollY > 12;
    /* Visual class only — never hide / translate the header */
    headerScrollEl.classList.toggle('ev-header--scrolled', isScrolled);
    headerScrollEl.classList.toggle('is-scrolled', isScrolled);
    syncScrollOffset();
  }

  function onHeaderScroll() {
    if (headerScrollRaf !== null) return;
    headerScrollRaf = window.requestAnimationFrame(function () {
      headerScrollRaf = null;
      updateHeaderScrollState();
    });
  }

  function initHeaderScroll() {
    headerScrollEl = document.querySelector('[data-ev-header]');
    if (!headerScrollEl) return;

    updateHeaderScrollState();

    if (headerScrollBound) return;
    headerScrollBound = true;

    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    window.addEventListener('resize', syncScrollOffset, { passive: true });
  }

  function initMobileMenu() {
    var menu = document.getElementById('ev-mobile-menu');
    var openBtn = document.querySelector('[data-ev-menu-open]');
    if (!menu || !openBtn) return;
    var panel = menu.querySelector('.ev-mobile-menu__panel');
    var closeTimer = null;

    function setOpen(isOpen) {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      if (isOpen) {
        menu.hidden = false;
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('ev-menu-open');
        window.requestAnimationFrame(function () {
          menu.classList.add('is-open');
        });
        var focusTarget = menu.querySelector('[data-ev-menu-close]');
        if (focusTarget) focusTarget.focus();
        return;
      }

      menu.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ev-menu-open');
      closeTimer = window.setTimeout(function () {
        menu.hidden = true;
        closeTimer = null;
      }, 380);
    }

    openBtn.addEventListener('click', function () {
      setOpen(true);
    });

    menu.querySelectorAll('[data-ev-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) setOpen(false);
    });

    if (panel) {
      panel.addEventListener('transitionend', function (event) {
        if (event.propertyName !== 'transform') return;
        if (!menu.classList.contains('is-open') && !menu.hidden) {
          menu.hidden = true;
        }
      });
    }
  }

  function initAddToCartButtons() {
    document.querySelectorAll('[data-ev-add-to-cart]').forEach(function (btn) {
      if (btn.dataset.evCartBound === 'true') return;
      btn.dataset.evCartBound = 'true';

      btn.addEventListener('click', function () {
        var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!variantId || isNaN(variantId)) {
          var productUrl = btn.getAttribute('data-product-url');
          if (productUrl) {
            window.location.href = productUrl;
          }
          return;
        }

        btn.disabled = true;
        addVariantToCart(variantId)
          .then(handleCartAddSuccess)
          .catch(function (error) {
            console.error('[EliteVault] add to cart failed:', error);
            alert(error.message || 'Could not add to cart.');
          })
          .finally(function () {
            btn.disabled = false;
          });
      });
    });
  }

  function initEvFaq() {
    document.querySelectorAll('[data-ev-faq]').forEach(function (faqRoot) {
      var homepageFaq = faqRoot.getAttribute('data-ev-faq-single-desktop') === 'true';
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function closeItem(item) {
        var trigger = item.querySelector('[data-ev-faq-trigger]');
        var panel = item.querySelector('[data-ev-faq-panel]');
        if (!panel) return;
        item.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        panel.style.height = panel.scrollHeight + 'px';
        panel.offsetHeight;
        panel.style.height = '0px';
        window.setTimeout(function () {
          if (!item.classList.contains('is-open')) panel.hidden = true;
        }, reduceMotion ? 0 : 280);
      }

      function openItem(item) {
        var trigger = item.querySelector('[data-ev-faq-trigger]');
        var panel = item.querySelector('[data-ev-faq-panel]');
        if (!panel) return;
        item.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        panel.style.height = '0px';
        panel.offsetHeight;
        panel.style.height = panel.scrollHeight + 'px';
      }

      faqRoot.querySelectorAll('[data-ev-faq-trigger]').forEach(function (trigger) {
        if (trigger.dataset.evFaqBound === 'true') return;
        trigger.dataset.evFaqBound = 'true';

        var item = trigger.closest('.ev-faq__item');
        var panel = item ? item.querySelector('[data-ev-faq-panel]') : null;
        if (!panel) return;

        panel.hidden = true;
        panel.style.height = '0px';

        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          /* Homepage: one open on desktop; independent on mobile. Elsewhere: keep single-open. */
          var forceSingle = !homepageFaq || window.matchMedia('(min-width: 768px)').matches;

          if (forceSingle) {
            faqRoot.querySelectorAll('.ev-faq__item.is-open').forEach(function (opened) {
              if (opened !== item) closeItem(opened);
            });
          }

          if (isOpen) {
            closeItem(item);
          } else {
            openItem(item);
          }
        });
      });
    });
  }

  function syncHeroVisualCutoff() {
    var hero = document.querySelector('.ev-hero');
    if (!hero) return;

    if (window.innerWidth < 1024) {
      hero.style.removeProperty('--ev-hero-visual-cutoff');
      return;
    }

    var media = hero.querySelector('.ev-hero__media');
    if (!media) return;

    var heroTop = hero.getBoundingClientRect().top;
    var mediaBottom = media.getBoundingClientRect().bottom;
    var cutoff = mediaBottom - heroTop + 32;

    hero.style.setProperty('--ev-hero-visual-cutoff', Math.max(0, cutoff) + 'px');
  }

  var heroCutoffRaf = 0;

  function scheduleHeroVisualCutoff() {
    if (heroCutoffRaf) return;
    heroCutoffRaf = window.requestAnimationFrame(function () {
      heroCutoffRaf = 0;
      syncHeroVisualCutoff();
    });
  }

  function initHeroVisualCutoff() {
    scheduleHeroVisualCutoff();

    if (initHeroVisualCutoff.bound) return;
    initHeroVisualCutoff.bound = true;

    window.addEventListener('resize', scheduleHeroVisualCutoff, { passive: true });
    window.addEventListener('load', scheduleHeroVisualCutoff, { passive: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleHeroVisualCutoff).catch(function () {});
    }
  }

  function initReviewsCarousel() {
    document.querySelectorAll('[data-ev-reviews]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-ev-reviews-track]');
      var prev = carousel.querySelector('[data-ev-reviews-prev]');
      var next = carousel.querySelector('[data-ev-reviews-next]');
      if (!track || !prev || !next) return;
      if (carousel.dataset.evReviewsBound === 'true') return;
      carousel.dataset.evReviewsBound = 'true';

      function scrollByCard(direction) {
        var card = track.querySelector('.ev-review-card');
        var gap = 20;
        var amount = card ? card.offsetWidth + gap : track.clientWidth * 0.85;
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { scrollByCard(-1); });
      next.addEventListener('click', function () { scrollByCard(1); });
    });
  }

  function initAnchorScroll() {
    if (initAnchorScroll.bound) return;
    initAnchorScroll.bound = true;

    function scrollToHashTarget(target, behavior) {
      if (!target) return;
      var offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ev-scroll-offset')) || 0;
      var targetTop = target.getBoundingClientRect().top + window.pageYOffset;
      var scrollTop = targetTop - offset;

      if (target.id === 'shop') {
        var hero = document.querySelector('.ev-hero');
        if (hero) {
          scrollTop = hero.getBoundingClientRect().bottom + window.pageYOffset;
        } else {
          scrollTop = targetTop;
        }
      }

      window.scrollTo({ top: Math.max(0, scrollTop), behavior: behavior || 'smooth' });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href*="#"]');
      if (!link) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      if (!url.hash || url.hash.length < 2) return;

      var target = document.querySelector(url.hash);
      if (!target) return;

      event.preventDefault();
      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      scrollToHashTarget(target, behavior);
      history.pushState(null, '', url.hash);
    });

    function scrollInitialHash() {
      if (!window.location.hash) return;
      var initialTarget = document.querySelector(window.location.hash);
      if (!initialTarget) return;
      scrollToHashTarget(initialTarget, 'auto');
    }

    window.requestAnimationFrame(scrollInitialHash);
    window.addEventListener('load', scrollInitialHash, { passive: true });
  }

  /**
   * Homepage fresh loads: browsers (esp. mobile) restore a mid-page scroll offset.
   * One controlled reset for navigate/reload without a hash. Skip back_forward,
   * Theme Editor, hashes, and any user scroll that already started.
   */
  function initHomepageFreshLoadTop() {
    if (initHomepageFreshLoadTop.bound) return;
    initHomepageFreshLoadTop.bound = true;

    var isHomepage =
      document.body.classList.contains('template-index') ||
      document.documentElement.classList.contains('template-index');
    if (!isHomepage) return;
    if (window.location.hash) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var navEntry =
      window.performance &&
      typeof window.performance.getEntriesByType === 'function' &&
      window.performance.getEntriesByType('navigation')[0];

    if (navEntry && navEntry.type === 'back_forward') return;
    if (
      !navEntry &&
      window.performance &&
      window.performance.navigation &&
      window.performance.navigation.type === 2
    ) {
      return;
    }

    var userScrolled = false;
    var finished = false;
    var pinning = false;

    function markUserScrolled() {
      if (pinning || finished) return;
      userScrolled = true;
    }

    function onUserScroll() {
      if (pinning || finished) return;
      if (window.pageYOffset > 8 || document.documentElement.scrollTop > 8) {
        userScrolled = true;
      }
    }

    function pinTop() {
      if (userScrolled) return;
      if (window.location.hash) return;
      pinning = true;
      window.scrollTo(0, 0);
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
      pinning = false;
    }

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    pinTop();
    window.addEventListener('scroll', onUserScroll, { passive: true });
    window.addEventListener('wheel', markUserScrolled, { passive: true });
    window.addEventListener('touchmove', markUserScrolled, { passive: true });

    function cleanupScrollWatch() {
      window.removeEventListener('scroll', onUserScroll);
      window.removeEventListener('wheel', markUserScrolled);
      window.removeEventListener('touchmove', markUserScrolled);
    }

    function restoreAutoScroll() {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    }

    function finish() {
      if (finished) return;
      finished = true;
      /* One post-render safety pin, then release restoration control. */
      pinTop();
      window.requestAnimationFrame(function () {
        pinTop();
        cleanupScrollWatch();
        restoreAutoScroll();
      });
    }

    function onPageShow(event) {
      if (event.persisted) {
        /* bfcache back/forward — do not force Hero. */
        finished = true;
        cleanupScrollWatch();
        restoreAutoScroll();
        return;
      }
      pinTop();
    }

    window.addEventListener('pageshow', onPageShow, { once: true });

    if (document.readyState === 'complete') {
      finish();
    } else {
      window.addEventListener('load', finish, { once: true, passive: true });
    }
  }

  function initSectionReveal() {
    document.querySelectorAll('[data-ev-section-reveal], [data-ev-philosophy], [data-ev-lifestyle-reveal], [data-ev-why-reveal], [data-ev-shipping-reveal], [data-ev-newsletter-reveal]').forEach(function (section) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.classList.add('is-visible');
        return;
      }

      if (!('IntersectionObserver' in window)) {
        section.classList.add('is-visible');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
      );

      observer.observe(section);
    });
  }

  function destroyCustomerReviewsCarousel(root) {
    if (!root) return;
    if (typeof root._evCrvDestroy === 'function') {
      root._evCrvDestroy();
      root._evCrvDestroy = null;
    }
    delete root.dataset.evCrvBound;
  }

  function initCustomerReviewsCarousel(scope) {
    var EASE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
    var TRANSITION_MS = 800;
    var RESUME_DELAY_MS = 5000;
    var AUTOPLAY_DEFAULT_MS = 2500;
    var AUTOPLAY_MIN_MS = 2500;
    var rootScope = scope || document;

    rootScope.querySelectorAll('[data-ev-crv-carousel]').forEach(function (root) {
      if (root.dataset.evCrvBound === 'true') return;

      var viewport = root.querySelector('[data-ev-crv-viewport]');
      var track = root.querySelector('[data-ev-crv-track]');
      var prevBtn = root.querySelector('[data-ev-crv-prev]');
      var nextBtn = root.querySelector('[data-ev-crv-next]');
      var statusEl = root.querySelector('[data-ev-crv-status]');
      if (!viewport || !track) return;

      root.dataset.evCrvBound = 'true';

      var reducedMotionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
      var reducedMotion = reducedMotionMq.matches;
      var autoplaySetting = root.getAttribute('data-autoplay') !== 'false';
      var autoplayEnabled = autoplaySetting && !reducedMotion;
      var autoplayMs = parseInt(root.dataset.autoplayMs, 10) || AUTOPLAY_DEFAULT_MS;
      if (autoplayMs < AUTOPLAY_MIN_MS) autoplayMs = AUTOPLAY_MIN_MS;

      var realSlides = Array.prototype.filter.call(track.children, function (slide) {
        return !slide.hasAttribute('data-ev-crv-clone');
      });
      var total = realSlides.length;
      if (total === 0) {
        delete root.dataset.evCrvBound;
        return;
      }

      var abort = new AbortController();
      var signal = abort.signal;
      var autoplayTimer = null;
      var resumeTimer = null;
      var resizeTimer = null;
      var editorPaused = false;

      if (statusEl) statusEl.setAttribute('aria-live', 'off');

      if (total === 1) {
        realSlides[0].classList.add('is-active');
        root._evCrvDestroy = function () {
          abort.abort();
          if (autoplayTimer) window.clearInterval(autoplayTimer);
          if (resumeTimer) window.clearTimeout(resumeTimer);
          if (resizeTimer) window.clearTimeout(resizeTimer);
        };
        return;
      }

      function cloneSlide(slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('data-ev-crv-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach(function (node) {
          node.removeAttribute('id');
        });
        /* Clones must not expose Shopify editor block attrs or confuse SR. */
        clone.removeAttribute('data-shopify-editor-block');
        clone.classList.remove('is-active', 'is-adjacent');
        return clone;
      }

      var cloneCount = Math.min(3, total);
      var leading = realSlides.slice(-cloneCount).map(cloneSlide);
      var trailing = realSlides.slice(0, cloneCount).map(cloneSlide);
      leading.forEach(function (clone) {
        track.insertBefore(clone, track.firstChild);
      });
      trailing.forEach(function (clone) {
        track.appendChild(clone);
      });

      var allSlides = Array.prototype.slice.call(track.children);
      var index = cloneCount;
      var isAnimating = false;
      var dragStartX = 0;
      var dragDelta = 0;
      var isDragging = false;
      var pointerId = null;

      function getVisible() {
        var raw = window.getComputedStyle(root).getPropertyValue('--ev-crv-visible').trim();
        var n = parseFloat(raw);
        if (n > 0) return Math.max(1, Math.round(n));
        if (window.matchMedia('(min-width: 1024px)').matches) return 3;
        if (window.matchMedia('(min-width: 768px)').matches) return 2;
        return 1;
      }

      function getStride() {
        var slide = allSlides[0];
        if (!slide) return 0;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        return slide.offsetWidth + gap;
      }

      function realIndexFromAll(idx) {
        return ((idx - cloneCount) % total + total) % total;
      }

      function setTransition(on) {
        if (reducedMotion || !on) {
          track.style.transition = 'none';
          return;
        }
        track.style.transition = 'transform ' + TRANSITION_MS + 'ms ' + EASE;
      }

      function stabilizeHeight() {
        var maxH = 0;
        realSlides.forEach(function (slide) {
          var card = slide.querySelector('.ev-crv-card');
          if (card) card.style.minHeight = '';
        });
        /* Force reflow at natural content height before measuring */
        void track.offsetHeight;
        realSlides.forEach(function (slide) {
          maxH = Math.max(maxH, slide.offsetHeight || 0);
        });
        if (maxH > 0) {
          root.style.setProperty('--ev-reviews-card-min-height', maxH + 'px');
          viewport.style.minHeight = maxH + 'px';
          realSlides.forEach(function (slide) {
            var card = slide.querySelector('.ev-crv-card');
            if (card) card.style.minHeight = maxH + 'px';
          });
          allSlides.forEach(function (slide) {
            if (slide.hasAttribute('data-ev-crv-clone')) {
              var cloneCard = slide.querySelector('.ev-crv-card');
              if (cloneCard) cloneCard.style.minHeight = maxH + 'px';
            }
          });
        }
      }

      function updateSlideStates() {
        allSlides.forEach(function (slide, i) {
          slide.classList.remove('is-active', 'is-adjacent');
          var distance = Math.abs(i - index);
          if (distance === 0) {
            slide.classList.add('is-active');
          } else if (distance === 1) {
            slide.classList.add('is-adjacent');
          }
        });
      }

      function announceStatus() {
        if (!statusEl) return;
        var current = realIndexFromAll(index) + 1;
        statusEl.textContent = 'Review ' + current + ' of ' + total;
      }

      function positionTrack(animate) {
        var stride = getStride();
        var viewportW = viewport.offsetWidth;
        var slideW = allSlides[0] ? allSlides[0].offsetWidth : 0;
        var visible = getVisible();
        var offset;

        if (visible === 1) {
          offset = viewportW / 2 - slideW / 2 - index * stride + dragDelta;
        } else {
          offset = -index * stride + dragDelta;
        }

        setTransition(animate);
        track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
        updateSlideStates();
        announceStatus();
      }

      function jumpWithoutAnimation(newIndex) {
        index = newIndex;
        positionTrack(false);
      }

      function goTo(nextIndex, animate) {
        if (isAnimating && animate) return;
        var animateTransition = animate !== false && !reducedMotion;
        if (animateTransition) isAnimating = true;
        index = nextIndex;
        positionTrack(animateTransition);
        if (!animateTransition) isAnimating = false;
      }

      function goNext() {
        goTo(index + 1, true);
      }

      function goPrev() {
        goTo(index - 1, true);
      }

      function goToRealIndex(realIdx, animate) {
        if (realIdx < 0 || realIdx >= total) return;
        goTo(cloneCount + realIdx, animate !== false);
      }

      function handleLoopEnd() {
        if (index >= cloneCount + total) {
          jumpWithoutAnimation(index - total);
        } else if (index < cloneCount) {
          jumpWithoutAnimation(index + total);
        }
        isAnimating = false;
      }

      function clearAutoplay() {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function startAutoplay() {
        clearAutoplay();
        if (!autoplayEnabled || editorPaused || document.hidden || reducedMotion) return;
        if (statusEl) statusEl.setAttribute('aria-live', 'off');
        autoplayTimer = window.setInterval(function () {
          if (!isDragging && !isAnimating && !editorPaused) goNext();
        }, autoplayMs);
      }

      function pauseAutoplay() {
        clearAutoplay();
        if (resumeTimer) {
          window.clearTimeout(resumeTimer);
          resumeTimer = null;
        }
      }

      function scheduleAutoplayResume() {
        if (!autoplayEnabled || editorPaused || reducedMotion) return;
        if (resumeTimer) window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(startAutoplay, RESUME_DELAY_MS);
      }

      function userInteract() {
        pauseAutoplay();
        scheduleAutoplayResume();
      }

      function onReducedMotionChange() {
        reducedMotion = reducedMotionMq.matches;
        autoplayEnabled = autoplaySetting && !reducedMotion;
        if (!autoplayEnabled) {
          pauseAutoplay();
          setTransition(false);
        } else if (!editorPaused) {
          scheduleAutoplayResume();
        }
      }

      track.addEventListener(
        'transitionend',
        function (event) {
          if (event.target !== track || event.propertyName !== 'transform') return;
          handleLoopEnd();
          isAnimating = false;
        },
        { signal: signal }
      );

      if (prevBtn) {
        prevBtn.addEventListener(
          'click',
          function () {
            userInteract();
            goPrev();
          },
          { signal: signal }
        );
      }

      if (nextBtn) {
        nextBtn.addEventListener(
          'click',
          function () {
            userInteract();
            goNext();
          },
          { signal: signal }
        );
      }

      root.addEventListener('mouseenter', pauseAutoplay, { signal: signal });
      root.addEventListener('mouseleave', scheduleAutoplayResume, { signal: signal });
      root.addEventListener('focusin', pauseAutoplay, { signal: signal });
      root.addEventListener(
        'focusout',
        function (event) {
          if (!root.contains(event.relatedTarget)) scheduleAutoplayResume();
        },
        { signal: signal }
      );

      document.addEventListener(
        'visibilitychange',
        function () {
          if (document.hidden) {
            pauseAutoplay();
          } else if (!editorPaused) {
            scheduleAutoplayResume();
          }
        },
        { signal: signal }
      );

      if (typeof reducedMotionMq.addEventListener === 'function') {
        reducedMotionMq.addEventListener('change', onReducedMotionChange, { signal: signal });
      } else if (typeof reducedMotionMq.addListener === 'function') {
        reducedMotionMq.addListener(onReducedMotionChange);
      }

      viewport.addEventListener(
        'keydown',
        function (event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            userInteract();
            goPrev();
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            userInteract();
            goNext();
          }
        },
        { signal: signal }
      );

      function onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isDragging = true;
        pointerId = event.pointerId;
        dragStartX = event.clientX;
        dragDelta = 0;
        viewport.classList.add('is-dragging');
        pauseAutoplay();
        setTransition(false);
        try {
          viewport.setPointerCapture(pointerId);
        } catch (err) {}
      }

      function onPointerMove(event) {
        if (!isDragging || event.pointerId !== pointerId) return;
        dragDelta = event.clientX - dragStartX;
        positionTrack(false);
      }

      function onPointerUp(event) {
        if (!isDragging || event.pointerId !== pointerId) return;
        isDragging = false;
        viewport.classList.remove('is-dragging');
        try {
          viewport.releasePointerCapture(pointerId);
        } catch (err) {}
        pointerId = null;
        var threshold = Math.min(80, getStride() * 0.18);
        if (dragDelta <= -threshold) {
          dragDelta = 0;
          userInteract();
          goNext();
        } else if (dragDelta >= threshold) {
          dragDelta = 0;
          userInteract();
          goPrev();
        } else {
          dragDelta = 0;
          positionTrack(!reducedMotion);
          scheduleAutoplayResume();
        }
      }

      viewport.addEventListener('pointerdown', onPointerDown, { signal: signal });
      viewport.addEventListener('pointermove', onPointerMove, { signal: signal });
      viewport.addEventListener('pointerup', onPointerUp, { signal: signal });
      viewport.addEventListener('pointercancel', onPointerUp, { signal: signal });

      window.addEventListener(
        'resize',
        function () {
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function () {
            stabilizeHeight();
            positionTrack(false);
          }, 120);
        },
        { signal: signal }
      );

      root.addEventListener(
        'click',
        function (event) {
          var btn = event.target.closest('[data-ev-crv-read-more]');
          if (!btn || !root.contains(btn)) return;
          var wrap = btn.closest('.ev-crv-card__text-wrap');
          if (!wrap) return;
          var expanded = wrap.classList.toggle('is-expanded');
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          btn.textContent = expanded ? 'Read less' : 'Read more';
          stabilizeHeight();
        },
        { signal: signal }
      );

      root._evCrvApi = {
        pause: function () {
          editorPaused = true;
          pauseAutoplay();
        },
        resume: function () {
          editorPaused = false;
          scheduleAutoplayResume();
        },
        goToRealIndex: goToRealIndex,
        getRealSlides: function () {
          return realSlides;
        }
      };

      root._evCrvDestroy = function () {
        pauseAutoplay();
        abort.abort();
        if (typeof reducedMotionMq.removeListener === 'function') {
          try {
            reducedMotionMq.removeListener(onReducedMotionChange);
          } catch (err) {}
        }
        if (resizeTimer) window.clearTimeout(resizeTimer);
        /* Remove clones added by this instance */
        track.querySelectorAll('[data-ev-crv-clone]').forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
        track.style.transition = '';
        track.style.transform = '';
        viewport.style.minHeight = '';
        root.style.removeProperty('--ev-reviews-card-min-height');
        track.querySelectorAll('.ev-crv-card').forEach(function (card) {
          card.style.minHeight = '';
        });
        root._evCrvApi = null;
      };

      stabilizeHeight();
      positionTrack(false);
      if (autoplayEnabled) startAutoplay();
    });
  }

  function findCustomerReviewsCarousel(fromNode) {
    if (!fromNode) return null;
    if (fromNode.matches && fromNode.matches('[data-ev-crv-carousel]')) return fromNode;
    if (fromNode.querySelector) {
      var nested = fromNode.querySelector('[data-ev-crv-carousel]');
      if (nested) return nested;
    }
    return fromNode.closest ? fromNode.closest('[data-ev-crv-carousel]') : null;
  }

  function handleCustomerReviewsBlockSelect(event) {
    var sectionEl = event.target;
    var root = findCustomerReviewsCarousel(sectionEl);
    if (!root || !root._evCrvApi) return;
    root._evCrvApi.pause();

    var blockId = event.detail && event.detail.blockId;
    if (!blockId) return;
    var slides = root._evCrvApi.getRealSlides();
    for (var i = 0; i < slides.length; i++) {
      var attr = slides[i].getAttribute('data-shopify-editor-block') || '';
      if (attr.indexOf(blockId) !== -1 || slides[i].id === 'shopify-block-' + blockId) {
        root._evCrvApi.goToRealIndex(i, true);
        break;
      }
      /* Shopify also stamps shopify_attributes as data-block-id in some builds */
      if (slides[i].dataset && slides[i].dataset.blockId === blockId) {
        root._evCrvApi.goToRealIndex(i, true);
        break;
      }
    }
  }

  function handleCustomerReviewsBlockDeselect(event) {
    var root = findCustomerReviewsCarousel(event.target);
    if (!root || !root._evCrvApi) return;
    root._evCrvApi.resume();
  }

  function initialize() {
    initHomepageFreshLoadTop();
    initHeaderScroll();
    initAnchorScroll();
    initMobileMenu();
    initAddToCartButtons();
    initEvFaq();
    initReviewsCarousel();
    initHeroVisualCutoff();
    initSectionReveal();
    initCustomerReviewsCarousel();
    fetchAndSyncCart();
  }

  window.EV = window.EV || {};
  window.EV.addVariantToCart = addVariantToCart;
  window.EV.addItemsToCart = addItemsToCart;
  window.EV.updateCartCount = updateCartCount;
  window.EV.syncCartState = syncCartState;
  window.EV.fetchAndSyncCart = fetchAndSyncCart;
  window.EV.handleCartAddSuccess = handleCartAddSuccess;
  window.EV.initCustomerReviewsCarousel = initCustomerReviewsCarousel;
  window.EV.destroyCustomerReviewsCarousel = destroyCustomerReviewsCarousel;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (section && section.querySelector && section.querySelector('[data-ev-crv-carousel]')) {
      destroyCustomerReviewsCarousel(section.querySelector('[data-ev-crv-carousel]'));
      initCustomerReviewsCarousel(section);
      return;
    }
    initialize();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;
    if (!section || !section.querySelector) return;
    var root = section.querySelector('[data-ev-crv-carousel]');
    if (root) destroyCustomerReviewsCarousel(root);
  });

  document.addEventListener('shopify:block:select', handleCustomerReviewsBlockSelect);
  document.addEventListener('shopify:block:deselect', handleCustomerReviewsBlockDeselect);
})();
